var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"style":{"fill":"#2488FF"},"points":"386.258,89.796 207.248,268.223 28.238,89.796 0,118.126 207.248,324.7 414.496,118.126 "}));
}

Chevron.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 414.496 414.496","style":{"enableBackground":"new 0 0 414.496 414.496"},"xmlSpace":"preserve"};

module.exports = Chevron;

Chevron.default = Chevron;
